import { DynamicQuestion, SurveySection } from "./types";

// Standard Lists used across the app (can be referenced or copied into options)
export const HOUSE_OWNERSHIP = ['സ്വന്തം', 'കോളനി', 'സ്വപാധിക ഉടമസ്ഥത', 'വാടക', 'പുറമ്പോക്'];
export const HOUSE_CONDITION = ['ഓട്', 'ഭാഗിക ടെറസ്', 'ഒറ്റനില ടെറസ്', 'ഇരുനില മാളിക', 'ബംഗ്ലാവ്'];
export const HOUSE_FACILITIES = ['വൈദ്യുതി', 'ഗ്യാസ്', 'കിണർ', 'പൊതുടാപ്പ്', 'വാട്ടർ സപ്ലൈ', 'പൊതു കിണർ'];
export const VEHICLES = ['സൈക്കിൾ', 'ടു വീലർ', 'ത്രീ വീലർ', 'കാർ', 'മറ്റുള്ളവ'];
export const ASSETS = ['ഭൂസ്വത്ത്', 'കൃഷി നിലം', 'വാടക കെട്ടിടം'];
export const AGRICULTURE = ['തെങ്ങ്', 'കവുങ്ങ്', 'റബ്ബർ', 'നെൽകൃഷി', 'പച്ചക്കറി', 'പുഷ്പം'];
export const HEALTH_CONDITIONS = [
  'സംതൃപ്തം', 'പ്രമേഹം', 'പ്രഷർ', 'ഹൃദ്രോഗം', 'ക്ഷയം', 'വാതം', 'ആസ്തമ', 'ക്യാൻസർ',
  'തിമിരം', 'കിഡ്‌നി രോഗം', 'ത്വക് രോഗം', 'ദന്ത രോഗങ്ങൾ', 'ഉദര രോഗങ്ങൾ',
  'മാനസികം', 'അംഗവൈകല്യം', 'അന്ധത / ബധിരത / മൂകത', 'മറ്റേതെങ്കിലും'
];
export const SOCIAL_WORK_OPTIONS = [
  'രാഷ്‌ടീയം', 'മത സംഘടന', 'സർവീസ് സംഘടന', 'സന്നദ്ധ പ്രവർത്തനം',
  'മഹല്ല് പ്രവർത്തനം', 'മറ്റേതെങ്കിലും', 'പ്രവാസി സംഘടന'
];

export const INITIAL_SECTIONS: SurveySection[] = [
  { id: 'sectionA', label: 'Section A: Household Info', order: 0, isRepeater: false },
  { id: 'sectionB', label: 'Section B: Family Members', order: 1, isRepeater: true },
  { id: 'sectionC', label: 'Section C: House & Assets', order: 2, isRepeater: false },
  { id: 'sectionD', label: 'Section D: General Info', order: 3, isRepeater: false },
];

// These questions will be loaded into storage if empty
export const INITIAL_QUESTIONS: DynamicQuestion[] = [
  // --- SECTION A ---
  { id: 'serialNo', label: 'ക്രമനമ്പർ (Serial No)', type: 'text', section: 'sectionA', required: true },
  { id: 'headName', label: 'കുടുംബ നാഥൻ / നാഥ', type: 'text', section: 'sectionA', required: true },
  { id: 'houseName', label: 'വീട്ട് പേര്', type: 'text', section: 'sectionA', required: true },
  { id: 'wardNo', label: 'വാർഡ് നമ്പർ', type: 'text', section: 'sectionA', required: true },
  { id: 'houseNo', label: 'വീട്ട് നമ്പർ', type: 'text', section: 'sectionA', required: true },
  { id: 'phone', label: 'മൊബൈൽ ഫോൺ നമ്പർ', type: 'text', section: 'sectionA', required: true },
  { id: 'amsham', label: 'അംശം', type: 'text', section: 'sectionA' },
  { id: 'desham', label: 'ദേശം', type: 'text', section: 'sectionA' },
  { id: 'post', label: 'പോസ്റ്റ്', type: 'text', section: 'sectionA' },
  { id: 'pin', label: 'പിൻ', type: 'number', section: 'sectionA' },
  { id: 'village', label: 'വില്ലജ്', type: 'text', section: 'sectionA' },

  // --- SECTION B (Family Members) ---
  { id: 'name', label: 'പേര്', type: 'text', section: 'sectionB', required: true },
  { id: 'gender', label: 'ലിംഗം (Gender)', type: 'dropdown', options: ['Male', 'Female'], section: 'sectionB', required: true },
  { id: 'age', label: 'വയസ്സ്', type: 'number', section: 'sectionB', required: true },
  { id: 'relation', label: 'കുടുംബ നാഥനുമായുള്ള ബന്ധം', type: 'dropdown', options: ['Father', 'Mother', 'Spouse', 'Child', 'Sibling', 'Other'], section: 'sectionB', required: true },
  { id: 'maritalStatus', label: 'വൈവാഹിക നില', type: 'dropdown', options: ['Single', 'Married', 'Widowed', 'Abandoned'], section: 'sectionB' },
  
  // Dependent on Single
  { id: 'singleReason', label: 'അവിവാഹിതനാണെങ്കിൽ കാരണം', type: 'dropdown', section: 'sectionB', dependsOn: 'maritalStatus', visibleIf: 'Single', options: ['സമയമായിട്ടില്ല', 'അനാരോഗ്യം', 'സാമ്പത്തികം', 'താല്പര്യമില്ല', 'തൊഴിലില്ലായ്‌മ', 'മറ്റേതെങ്കിലും'] },
  
  // Dependent on Married/Widowed/Abandoned
  { id: 'maleKids', label: 'ആൺ മക്കൾ (എണ്ണം)', type: 'number', section: 'sectionB', dependsOn: 'maritalStatus', visibleIf: ['Married', 'Widowed', 'Abandoned'] },
  { id: 'femaleKids', label: 'പെൺ മക്കൾ (എണ്ണം)', type: 'number', section: 'sectionB', dependsOn: 'maritalStatus', visibleIf: ['Married', 'Widowed', 'Abandoned'] },

  // Education
  { id: 'edu_religious', label: 'മത വിദ്യാഭ്യാസം (1-12)', type: 'dropdown', section: 'sectionB', options: ['1','2','3','4','5','6','7','8','9','10','11','12'] },
  { id: 'edu_informal', label: 'ഒരപചാരിക വിദ്യാഭ്യാസം', type: 'text', section: 'sectionB' },
  { id: 'isStudying', label: 'പഠിക്കുന്നുണ്ടോ?', type: 'yesno', section: 'sectionB' },
  { id: 'edu_status', label: 'പഠന നിലവാരം', type: 'dropdown', section: 'sectionB', dependsOn: 'isStudying', visibleIf: true, options: ['High', 'Average', 'Low'] },
  { id: 'edu_institution', label: 'സ്ഥാപനം', type: 'text', section: 'sectionB', dependsOn: 'isStudying', visibleIf: true },

  // Job
  { id: 'unemployed', label: 'തൊഴിൽ രഹിതനാണോ?', type: 'yesno', section: 'sectionB' },
  { id: 'unemployedReason', label: 'കാരണം', type: 'dropdown', section: 'sectionB', dependsOn: 'unemployed', visibleIf: true, options: ['അനാരോഗ്യം', 'തൊഴിൽ ലഭ്യമല്ല', 'വിശ്രമ ജീവിതം', 'മറ്റുള്ളവ'] },
  { id: 'currentJob', label: 'തൊഴിൽ മേഖല', type: 'text', section: 'sectionB', dependsOn: 'unemployed', visibleIf: false },

  // Health
  { id: 'health_conditions', label: 'ആരോഗ്യം (MCQ)', type: 'multiselect', section: 'sectionB', options: HEALTH_CONDITIONS },
  { id: 'isSick', label: 'രോഗിയാണോ?', type: 'yesno', section: 'sectionB' },
  { id: 'treatmentStatus', label: 'ചികിത്സാ വിവരങ്ങൾ', type: 'dropdown', section: 'sectionB', dependsOn: 'isSick', visibleIf: true, options: ['ചികിത്സയിൽ ആണ്', 'ചികിത്സ ആവശ്യമില്ല', 'മറ്റുള്ളവ'] },
  { id: 'bloodGroup', label: 'രക്ത ഗ്രൂപ്പ്', type: 'dropdown', section: 'sectionB', options: ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'] },

  // NRI
  { id: 'isNRI', label: 'പ്രവാസിയാണോ?', type: 'yesno', section: 'sectionB' },
  { id: 'norkaCard', label: 'നോർക്ക കാർഡ് ഉണ്ടോ?', type: 'yesno', section: 'sectionB', dependsOn: 'isNRI', visibleIf: true },

  // Other Member fields
  { id: 'socialWork', label: 'സാമൂഹ്യ പ്രവർത്തനം', type: 'multiselect', section: 'sectionB', options: SOCIAL_WORK_OPTIONS },
  { id: 'needsPension', label: 'പെൻഷൻ ആവശ്യമുണ്ടോ?', type: 'yesno', section: 'sectionB' },
  { id: 'ambition', label: 'ജീവിതാഭിലാഷം', type: 'text', section: 'sectionB' },
  { id: 'isBPL', label: 'ബി പി എൽ (BPL) ആണോ?', type: 'yesno', section: 'sectionB' },
  { id: 'hasInsurance', label: 'ഇൻഷുറൻസ് ഉണ്ടോ?', type: 'yesno', section: 'sectionB' },
  { id: 'inVoterList', label: 'വോട്ടർ പട്ടികയിൽ ഉണ്ടോ?', type: 'yesno', section: 'sectionB' },
  { id: 'remarks', label: 'റിമാർക്സ്', type: 'text', section: 'sectionB' },

  // --- SECTION C (House & Assets) ---
  { id: 'ownership', label: 'വീട് ഉടമസ്ഥത', type: 'dropdown', section: 'sectionC', options: HOUSE_OWNERSHIP },
  { id: 'condition', label: 'വീടിന്റെ അവസ്ഥ', type: 'dropdown', section: 'sectionC', options: HOUSE_CONDITION },
  { id: 'roomCount', label: 'മുറികളുടെ എണ്ണം', type: 'number', section: 'sectionC' },
  { id: 'area', label: 'വിസ്തീർണം (sq ft)', type: 'number', section: 'sectionC' },
  { id: 'assets', label: 'ആസ്തി വിവരങ്ങൾ', type: 'multiselect', section: 'sectionC', options: ASSETS },
  { id: 'facilities', label: 'സൗകര്യങ്ങൾ', type: 'multiselect', section: 'sectionC', options: HOUSE_FACILITIES },
  { id: 'vehicles', label: 'വാഹനങ്ങൾ', type: 'multiselect', section: 'sectionC', options: VEHICLES },
  { id: 'agriculture', label: 'കൃഷി', type: 'multiselect', section: 'sectionC', options: AGRICULTURE },
  { id: 'housePhoto', label: 'ഫോട്ടോ (Photo)', type: 'image', section: 'sectionC' },
  { id: 'housePhoto2', label: 'ഫോട്ടോ 2 (Optional)', type: 'image', section: 'sectionC' },
  { id: 'housePhoto3', label: 'ഫോട്ടോ 3 (Optional)', type: 'image', section: 'sectionC' },
  
  // --- SECTION D (General) ---
  { id: 'aidStatus', label: 'സഹായം ലഭിക്കുന്നുണ്ടോ?', type: 'dropdown', section: 'sectionD', options: ['ഇല്ല', 'സർക്കാർ', 'മഹല്ല്', 'മറ്റുള്ളവ'] },
  { id: 'aidSource', label: 'എവിടെ നിന്ന്?', type: 'text', section: 'sectionD', dependsOn: 'aidStatus', visibleIf: ['സർക്കാർ', 'മഹല്ല്', 'മറ്റുള്ളവ'] },
  { id: 'parentEducationSupport', label: 'വിദ്യാഭ്യാസ പിന്തുണ', type: 'dropdown', section: 'sectionD', options: ['നല്ലത്', 'ശരാശരി', 'മോശം'] },
  { id: 'mahalContribution', label: 'മഹല്ല് സംഭാവന', type: 'dropdown', section: 'sectionD', options: ['മാസവരി', 'വാർഷികം', 'ഇല്ല'] },
  { id: 'informerName', label: 'വിവരം നൽകിയ ആൾ', type: 'text', section: 'sectionD' },
  { id: 'collectorName', label: 'വിവരം ശേഖരിച്ച ആൾ', type: 'text', section: 'sectionD' },
  { id: 'otherInfo', label: 'മറ്റു വിവരങ്ങൾ', type: 'textarea', section: 'sectionD' },
  { id: 'specialMahalInfo', label: 'പ്രത്യേകം അറിയിക്കാൻ ഉള്ളത്', type: 'textarea', section: 'sectionD' },
];